import { ICreateContasPagarUseCase } from "../../../presentation/useCases/create/create_contas_pagar_use_case";
import { ContasPagar } from "../../models/contas_pagar";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateContasPagarUseCase
 */

export class CreateContasPagarUseCase implements ICreateContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createContasPagar(form: ContasPagar): Promise<number> {
    return await this.repository.createContasPagar(form);

  }
}
